import NotificationIcon from './component'

export default NotificationIcon